<template>
  <div class="partners-page">
    <!-- Past Exhibit Highlights Hero Section -->
    <section class="past-highlights-section">
      <div class="highlights-overlay"></div>
      <div class="highlights-content">
        <h1 class="highlights-title">Past Exhibit Highlights:<br/>INTERNATIONAL EDU TRAVEL</h1>
        <button class="highlights-btn" @click="$router.push('/exhibit')">Exhibit</button>
      </div>
    </section>

    <!-- Past Exhibitors Section -->
    <section class="past-exhibitors-section">
      <div class="container-wide">
        <div class="exhibitors-grid">
          <div class="exhibitor-logo" v-for="(exhibitor, index) in exhibitors" :key="index">
            <img :src="exhibitor.logo" :alt="exhibitor.name" />
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="cta-content">
        <h2 class="cta-title">Be at the Heart of the INTERNATIONAL EDU TRAVEL, 2026</h2>
        <button class="cta-btn" @click="$router.push('/contact')">Exhibit Opportunities</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PartnersPage',
  data() {
    return {
      exhibitors: [
        { name: 'AIRIA', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/airia.webp' },
        { name: 'Freshworks', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/freshworks-2.webp' },
        { name: 'Salesforce', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Salesforce.webp' },
        { name: 'Dataiku', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/dataiku.webp' },
        { name: 'Multiverse Computing', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Multiverse-Computing-Participation.webp' },
        { name: 'DiAGEN.AI', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/diagenai.webp' },
        { name: 'Data Quantum', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Data-Quantum.webp' },
        { name: 'Sophia', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/sophia.webp' },
        { name: 'AMD Cybersec', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/amd-cybersec.webp' },
        { name: 'AeroAegis', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/aeroaegis.webp' },
        { name: 'WAND', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/wand.webp' },
        { name: 'Kyvos', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/kyvos.webp' },
        { name: 'Ksolves', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/ksolves.webp' },
        { name: 'Xcelore', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/xcelore.webp' },
        { name: 'Gathr', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/gathr.webp' },
        { name: 'Seez', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/seez.webp' },
        { name: 'Propty', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/propty.webp' },
        { name: 'Exotel', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Exotel.webp' },
        { name: 'TCALL', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/tcall.webp' },
        { name: 'SleekFlow', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/sleekflow.webp' },
        { name: 'Tring AI', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/tring_ai-e1750165847547.webp' },
        { name: 'GoGHR', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/goghr.webp' },
        { name: 'Mendcor', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/mendcor.webp' },
        { name: 'VentureDive', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/12/venturedive.webp' },
        { name: 'Qwerty Experts', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/12/Qwerty-Exprets.webp' },
        { name: 'Kama', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/12/Kama.webp' },
        { name: 'Tagglabs', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/Tagglabs.webp' },
        { name: 'SAAL', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/saal.svg' },
        { name: 'Amotion', logo: 'https://www.globalaishow.com/wp-content/uploads/2024/11/amotion.webp' }
      ]
    }
  }
}
</script>

<style scoped>
/* Past Highlights Hero Section */
.past-highlights-section {
  position: relative;
  padding: 200px 20px;
  background: linear-gradient(135deg, #6B2DD8 0%, #8B5CF6 50%, #A78BFA 100%);
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/08/bg-1.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: left;
  min-height: 600px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.past-highlights-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(107, 45, 216, 0.85) 0%, rgba(139, 92, 246, 0.75) 50%, rgba(167, 139, 250, 0.65) 100%);
  z-index: 0;
}

.highlights-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.highlights-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  width: 100%;
}

.highlights-title {
  font-size: 56px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 30px 0;
  line-height: 1.2;
  letter-spacing: -1px;
}

.highlights-btn {
  padding: 16px 48px;
  background: #ffffff;
  color: #6320EE;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
}

.highlights-btn:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 255, 255, 0.4);
}

/* Past Exhibitors Section */
.past-exhibitors-section {
  padding: 80px 20px;
  background: #ffffff;
}

.container-wide {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.exhibitors-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 25px;
  align-items: center;
}

.exhibitor-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
  min-height: 120px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.exhibitor-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  background: #ffffff;
}

.exhibitor-logo img {
  max-width: 100%;
  max-height: 70px;
  height: auto;
  width: auto;
  transition: all 0.3s ease;
}

.exhibitor-logo:hover img {
  transform: scale(1.05);
}

/* CTA Section */
.cta-section {
  padding: 100px 20px;
  background: linear-gradient(135deg, #2D1B69 0%, #4A2B8F 50%, #6B3FC7 100%);
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(139, 92, 246, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 50%, rgba(107, 45, 216, 0.3) 0%, transparent 50%);
  z-index: 0;
}

.cta-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.cta-title {
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 35px 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.cta-btn {
  padding: 18px 50px;
  background: #ffffff;
  color: #6320EE;
  border: none;
  border-radius: 50px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
}

.cta-btn:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(255, 255, 255, 0.4);
}

/* Responsive */
@media (max-width: 960px) {
  .past-highlights-section {
    padding: 150px 20px;
  }

  .highlights-content {
    padding: 0 20px;
  }

  .highlights-title {
    font-size: 42px;
  }

  .exhibitors-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .cta-title {
    font-size: 38px;
  }
}

@media (max-width: 600px) {
  .past-highlights-section {
    padding: 120px 15px;
    min-height: 500px;
  }

  .highlights-content {
    padding: 0 15px;
  }

  .highlights-title {
    font-size: 32px;
  }

  .highlights-btn {
    width: 100%;
    padding: 16px 32px;
  }

  .past-exhibitors-section {
    padding: 60px 15px;
  }

  .exhibitors-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .exhibitor-logo {
    padding: 20px;
    min-height: 100px;
  }

  .exhibitor-logo img {
    max-height: 60px;
  }

  .cta-section {
    padding: 80px 15px;
  }

  .cta-title {
    font-size: 28px;
  }

  .cta-btn {
    width: 100%;
    padding: 16px 40px;
  }
}
</style>
